import * as React from "react";
import { Row, Col, Alert } from "reactstrap";
import BasicTable from "../../../common/datatable/BasicTable";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"; // 937667 
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Constants } from "../../constants";

/**
 * Data Table State
 */
interface DataTableState {
  loading: boolean;
  triggerRender: boolean;
  data: any;
  message: any;
}

class DataTable extends React.Component<any, DataTableState> {
  // Contructor
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      triggerRender: true,
      data: [],
      message: { type: "success", isOpen: false, text: "" }
    };

    this.onAlertCloseAction = this.onAlertCloseAction.bind(this);
  }

  /**
   * Force the loading of the bank data once the page is rendered
   */
  componentDidMount() {
    this.setState({ loading: true }, () => {
      this.getBanks();
    });
  }

  /**
   * Fetch the bank list data
   */
  getBanks = () => {
    const URI = Constants.APP_API + Constants.BANKLIST_FETCH_URI;
    axios
      .get(URI)
      .then(resp => this.setState({ data: resp.data, loading: false }))
      .catch(err => {
        console.log(err);
        this.dataLoadErrorAlert();
        return null;
      });
  };

  /**
   * Notify the user that the bank list data filed to load
   */
  dataLoadErrorAlert() {
    this.setState({
      message: {
        type: "error",
        isOpen: true,
        text: Constants.BANKLIST_ERROR_LOAD
      },
      data: [],
      loading: false
    });
  }

  /**
   * Close the error Message alert
   */
  onAlertCloseAction() {
    this.setState({
      message: { type: "success", isOpen: false, text: "" }
    });
  }

  /**
   * Compunent Render function
   */
  render() {
    // Using built in realtime search filter
    const { SearchBar } = Search;

    // Data Table Columns details
    const columns = [
      {
        dataField: "fundCode",
        text: Constants.BANKLIST_HEADER_FUND,
        sort: true,
        headerAttrs: { scope: 'col', id: "pBankCode" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      },
      {
        dataField: "legalName",
        text: Constants.BANKLIST_HEADER_BANKNAME,
        sort: true,
        headerAttrs: { scope: 'col', id: "pBankName" },
        attrs: { tabIndex: '0' },
        classes: 'aria-focus'
      }
    ];

    // Data Table Default Sort
    const defaultSorted = [
      {
        dataField: "fundCode",
        order: "asc"
      }
    ];

    // Row Events
    const rowEvents = {
      onClick: (e: Event, row: any, rowIndex: string) => {
        // redirect user to the details page
        this.props.history.push(Constants.BANKLIST_BANK_URI + row.fundCode);
      }
    };

    const data = this.state.data;

    /** this is for the last updated date
        might be a better way to do this */
    // get all the dates
    const dates = data.map((d: any) => {
      return (new Date(d.publishedDate));
    });

    // get the largest date
    const lastDate = new Date(Math.max.apply(null, dates));

    // fromat date to string
    const lastDateString = (lastDate.getMonth() + 1) + "/" + lastDate.getDate() + "/" + lastDate.getFullYear();

    return (
      <Row>
        <Col md="12" lg="12" sm="auto">
          <h1 className="maintitle">{Constants.BANKLIST_TITLE}</h1>
          <hr />
          <p>
            <a href={Constants.APP_API + Constants.BANKLIST_EXCEL_LINK_URI} target="_blank" rel="noopener noreferrer">{Constants.BANKLIST_EXCEL_INSTRUCTIONS}</a>
            - {" "}
            {Constants.BANKLIST_EXCEL_LINK}
            (<a href={Constants.BANKLIST_EXCEL_HELP_URI} target="_blank" rel="noopener noreferrer">{Constants.BANKLIST_EXCEL_HELP}</a>)
          </p>
          <p><u>{Constants.BANKLIST_SUBTITLE}</u></p>
          <p>{Constants.BANKLIST_SUBTITLE1A}</p>
          <p>{Constants.BANKLIST_SUBTITLE1B}</p>
          <p><h2>{Constants.BANKLIST_SUBTITLE2}</h2></p>
          <p>{Constants.BANKLIST_INSTRUCTIONS}</p>

          <Alert
            color={this.state.message.type}
            isOpen={this.state.message.isOpen}
            toggle={this.onAlertCloseAction}
          >
            {this.state.message.text}
          </Alert>

          <ToolkitProvider
            bootstrap4
            keyField="fundCode"
            data={data}
            columns={columns}
            loading={this.state.loading}
            defaultSorted={defaultSorted}
            search
          >
            {(toolkitprops: any) => (
              <div className="dataTableWrapper">
                <SearchBar
                  {...toolkitprops.searchProps}
                  className="searchBar"
                />
                <BasicTable {...toolkitprops.baseProps} rowEvents={rowEvents} defaultSorted={defaultSorted} />
              </div>
            )}
          </ToolkitProvider>

          <div className="subfooter">
            <span>Last Updated: {lastDateString}</span><span><a href="mailto:cservicefdicdal@fdic.gov">Customer Service</a></span>
          </div>
        </Col>
      </Row>
    );
  }
}

export default withRouter(DataTable);
